import { Injectable } from "@angular/core";
import { AuthService } from "../authentication/auth.service";
import { OrganisationService } from "./organisation-services";

@Injectable()
export class PrimaryCurrencyService {
    private _primaryCurrencyCode: string;
    constructor(private authService: AuthService,
        private organisationService: OrganisationService) {
        this.organisationService.getOrganisation(this.authService.getSelectedOrganisation())
            .subscribe(
                organisation => {
                    this._primaryCurrencyCode = organisation.organisationCurrencies
                        ?.find(c => c.primaryFlag)
                        ?.currencyCode ?? null;
                }
            )
    }

    public getPrimaryCurrencyCode(): string {
        return this._primaryCurrencyCode;
    }
}